import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Accessibility from '../../components/Accessibility';
import Footer from '../../components/Layout/Footer';

import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

const LayoutWrapper = (props) => {
	const { children, siteId } = props;

	return (
		<>
			<Container
				disableGutters
				maxWidth={false}
				m={0}
				p={0}
				sx={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between',
					minHeight: '100vh'
				}}
			>
				<Stack>{children}</Stack>
				<Footer siteId={siteId} />
			</Container>
			<Accessibility />
		</>
	);
};

LayoutWrapper.propTypes = {
	children: PropTypes.node,
	siteId: PropTypes.number
};

const mapStateToProps = (state) => {
	return {
		siteId: state.authSlice.siteId
	};
};

export default connect(mapStateToProps, null)(LayoutWrapper);
